import { DurationFormat } from '@formatjs/intl-durationformat'

interface ActivityDurationState {
  isWorking: boolean
  startedAt?: number
}

export function useDocueAgentActivityDuration(getState: () => ActivityDurationState) {
  const { locale } = useI18n()
  const now = ref(0)

  const { pause, resume } = useIntervalFn(() => {
    now.value = Date.now()
  }, 1000, { immediate: false, immediateCallback: true })

  onMounted(() => {
    now.value = Date.now()
    if (getState().isWorking)
      resume()
  })

  watch(() => getState().isWorking, (isWorking) => {
    if (isWorking) {
      now.value = Date.now()
      resume()
    }
    else {
      pause()
    }
  })

  const elapsedSeconds = computed(() => {
    const { isWorking, startedAt } = getState()
    if (!isWorking || !startedAt || !now.value)
      return undefined
    return Math.max(1, Math.round((now.value - startedAt) / 1000))
  })

  function durationParts(seconds: number) {
    return {
      hours: Math.floor(seconds / 3600),
      minutes: Math.floor((seconds % 3600) / 60),
      seconds: seconds % 60,
    }
  }

  const narrowFormatter = computed(() =>
    new DurationFormat(locale.value.replaceAll('_', '-'), { style: 'narrow' }),
  )

  const elapsed = computed(() => elapsedSeconds.value === undefined
    ? undefined
    : narrowFormatter.value.format(durationParts(elapsedSeconds.value)),
  )

  return { elapsed }
}
